import { observer } from 'mobx-react-lite'
import { Checkbox, type CheckboxProps } from '@/components/inputs/Checkbox'
import type { FilterProps } from '@/infra/type-utils'
import {
  type ContainerProps,
  useFormFieldContainer,
} from '@/components/FormContainer'
import { FormField, FormFieldHint } from '@/components/Form'
import {
  SelectionLabel,
  SelectionLabelControl,
  SelectionLabelText,
} from './SelectionLabel'
import { action } from 'mobx'

/**
 * Form field container for a {@link Checkbox}.
 */
export const CheckboxContainer = observer(function CheckboxContainer<
  M extends object,
  K extends keyof FilterProps<M, boolean>,
>({
  name,
  model,
  label,
  hint,
  field,
  error,
  ...rest
}: ContainerProps<M, boolean, K, Omit<CheckboxProps, 'checked' | 'onChange'>>) {
  const { controlProps, hintProps, hintContent, labelProps } =
    useFormFieldContainer({
      name,
      model,
      field,
      hint,
      error,
    })

  return (
    <FormField>
      <SelectionLabel {...labelProps}>
        <SelectionLabelControl>
          <Checkbox
            {...controlProps}
            {...rest}
            checked={(model[field] as boolean) ?? false}
            onChange={action(`change ${field}`, (value) => {
              model[field] = value as M[K]
            })}
          />
        </SelectionLabelControl>
        <SelectionLabelText>{label}</SelectionLabelText>
      </SelectionLabel>
      <FormFieldHint {...hintProps}>{hintContent}</FormFieldHint>
    </FormField>
  )
})
